export default __webpack_public_path__ + "static/media/fauna-dashboard-framed.19fec7b2.png";